import { I18N_DEFAULT_LOCALE } from './constants/languages';

export default {
  fallbackLocale: I18N_DEFAULT_LOCALE,
};
